export default __webpack_public_path__ + "static/media/9295.d1501859.svg";